import { type ReactElement, useMemo } from 'react'
import { isDefined, isNotDefined, Workflow, type AccountSearchItem } from '@terros/common'
import { useProfile, useTinyUser, useWorkflow } from '@front/model'
import { toCompanyIconUrl } from '../map/workflowStageIcon'
import {
  AccountOwnerAvatar,
  AccountResultStageIcon,
  AccountStageActionIcon,
} from '../account/search/AccountResultIcons'
import classes from './spotlight.module.css'
import { SearchResultDetails } from './SearchResultDetails'

export const AccountSearchResultContents = ({ item }: { item: AccountSearchItem }): ReactElement => {
  const { data } = useWorkflow(item.workflowId)
  const { data: owner } = useTinyUser(item.ownerId)
  const { company } = useProfile()
  const workflow = useMemo(() => {
    if (isNotDefined(data) || data.isDeleted) return
    return new Workflow(data)
  }, [data])
  const stage = isDefined(item.workflowStageId) ? workflow?.getStage(item.workflowStageId) : undefined
  const visibleStage = isDefined(stage) && !stage.isDeleted ? stage : undefined
  const action = workflow?.getAction(item.workflowActionId)
  const workflowActionId = isDefined(action) && !action.isDeleted ? item.workflowActionId : undefined
  const stageIcon =
    isDefined(workflow) && isDefined(visibleStage) ? (
      <AccountStageActionIcon
        account={{ workflowStageId: item.workflowStageId, workflowActionId }}
        workflow={workflow}
        companyIconUrl={toCompanyIconUrl(company?.avatarUrl, company?.avatarBlurhash)}
        size='sm'
      />
    ) : undefined

  return (
    <>
      <span className={`${classes.entityAvatar} ${classes.accountStage}`}>
        <AccountResultStageIcon stageIcon={stageIcon} stageName={visibleStage?.name} />
      </span>
      <SearchResultDetails item={item} />
      <span className={classes.accountOwner}>
        {isDefined(owner) && !owner.isDeleted && <AccountOwnerAvatar account={{ ...item, owner }} />}
      </span>
    </>
  )
}
